<form class="user-grid" [formGroup]="userForm">
  <div class="grid-group">
    <div class="grid-column">
      <ng-container [ngTemplateOutlet]="userdata"></ng-container>
      <ng-container [ngTemplateOutlet]="platformroles"></ng-container>
    </div>
  </div>

  <div class="grid-group">
    <div class="grid-column">
      <ng-container [ngTemplateOutlet]="organizationdata"></ng-container>
      <ng-container [ngTemplateOutlet]="address"></ng-container>
    </div>
  </div>
  <div class="grid-group">
    <div class="grid-column">
      <ng-content select="[serviceroles]"></ng-content>
      <ng-content select="[groups]"></ng-content>
    </div>
  </div>

  <!--  card-templates -->
  <ng-template #userdata>
    <markant-platform-ui-card
      class="grid-item"
      [headline]="'user.details.masterdata' | transloco"
    >
      <markant-select
        *ngIf="userForm.controls['salutation'] as salutation"
        class="salutation"
        formControlName="salutation"
        [options]="salutationOptions"
        [showLabelHint]="true"
        [required]="true"
        [outlined]="true"
        [label]="'user.salutation.label' | transloco"
        [error]="
          salutation.errors
            | formControlKeyError
              : 'user.salutation.validation'
              : salutation.touched || salutation.dirty
            | transloco
        "
        [helper]="
          salutation.errors
            | formControlKeyError
              : 'user.salutation.validation'
              : salutation.touched || salutation.dirty
            | transloco
        "
      >
      </markant-select>
      <markant-input
        *ngIf="userForm.controls['firstname'] as firstName"
        formControlName="firstname"
        data-cy="input-firstname"
        autocomplete="given-name"
        [outlined]="true"
        [label]="'user.firstname.label' | transloco"
        [error]="
          firstName.errors
            | formControlError: firstName.touched || firstName.dirty
        "
        [errorText]="
          firstName.errors
            | formControlKeyError
              : 'user.firstname.validation'
              : firstName.touched || firstName.dirty
            | transloco
        "
        [showLabelHint]="true"
        [required]="true"
      >
      </markant-input>
      <markant-input
        *ngIf="userForm.controls['lastname'] as lastName"
        formControlName="lastname"
        data-cy="input-lastname"
        autocomplete="family-name"
        [outlined]="true"
        [label]="'user.lastname.label' | transloco"
        [error]="
          lastName.errors | formControlError: lastName.touched || lastName.dirty
        "
        [errorText]="
          lastName.errors
            | formControlKeyError
              : 'user.lastname.validation'
              : lastName.touched || lastName.dirty
            | transloco
        "
        [showLabelHint]="true"
        [required]="true"
      >
      </markant-input>
      @if (userForm.controls['email']; as email) {
        <markant-input
          formControlName="email"
          data-cy="input-email"
          autocomplete="email"
          [required]="email.enabled"
          [showLabelHint]="email.enabled"
          [outlined]="true"
          [label]="'user.email.label' | transloco"
          [helper]="
            noMailChangeReason
              ? ('user.email.helper.' + noMailChangeReason | transloco)
              : ''
          "
          [error]="
            email.errors | formControlError: email.touched || email.dirty
          "
          [errorText]="
            email.errors
              | formControlKeyError
                : 'user.email.validation'
                : email.touched || email.dirty
              | transloco
          "
        >
        </markant-input>
      }
      <markant-input
        *ngIf="userForm.controls['phone'] as phone"
        formControlName="phone"
        data-cy="input-phone"
        [outlined]="true"
        [label]="'user.phone.label' | transloco"
        [error]="phone.errors | formControlError: phone.touched || phone.dirty"
        [errorText]="
          phone.errors
            | formControlKeyError
              : 'user.phone.validation'
              : phone.touched || phone.dirty
            | transloco
        "
        [required]="false"
      >
      </markant-input>
      <markant-select
        *ngIf="userForm.controls['language'] as language"
        formControlName="language"
        name="language"
        [options]="languageOptions"
        [showLabelHint]="true"
        [required]="true"
        [outlined]="true"
        [label]="'user.language.label' | transloco"
        [error]="
          language.errors
            | formControlKeyError
              : 'user.language.validation'
              : language.touched || language.dirty
            | transloco
        "
        [helper]="
          language.errors
            | formControlKeyError
              : 'user.language.validation'
              : language.touched || language.dirty
            | transloco
        "
      >
      </markant-select>
    </markant-platform-ui-card>
  </ng-template>

  <ng-template #address>
    <markant-platform-ui-card
      class="grid-item"
      formGroupName="address"
      [headline]="'user.details.address' | transloco"
    >
      <div class="address address-street">
        <markant-input
          *ngIf="userForm.get('address.street') as street"
          formControlName="street"
          data-cy="input-street"
          [outlined]="true"
          [label]="'address.street' | transloco"
          [error]="
            street.errors | formControlError: street.touched || street.dirty
          "
          [errorText]="
            street.errors
              | formControlKeyError
                : 'address.streetValidation'
                : street.touched || street.dirty
              | transloco
          "
        >
        </markant-input>
        <markant-input
          *ngIf="userForm.get('address.streetNumber') as streetNumber"
          formControlName="streetNumber"
          data-cy="input-streetNumber"
          [outlined]="true"
          [label]="'address.streetNumber' | transloco"
          [error]="
            streetNumber.errors
              | formControlError: streetNumber.touched || streetNumber.dirty
          "
          [errorText]="
            streetNumber.errors
              | formControlKeyError
                : 'address.streetNumberValidation'
                : streetNumber.touched || streetNumber.dirty
              | transloco
          "
        >
        </markant-input>
      </div>
      <div class="address address-city">
        <markant-input
          *ngIf="userForm.get('address.zipCode') as zipcode"
          formControlName="zipCode"
          data-cy="input-zipCode"
          [outlined]="true"
          [label]="'address.zipcode' | transloco"
          [error]="
            zipcode.errors | formControlError: zipcode.touched || zipcode.dirty
          "
          [errorText]="
            zipcode.errors
              | formControlKeyError
                : 'address.zipCodeValidation'
                : zipcode.touched || zipcode.dirty
              | transloco
          "
        >
        </markant-input>
        <markant-input
          *ngIf="userForm.get('address.city') as city"
          formControlName="city"
          data-cy="input-city"
          [outlined]="true"
          [label]="'address.city' | transloco"
          [error]="city.errors | formControlError: city.touched || city.dirty"
          [errorText]="
            city.errors
              | formControlKeyError
                : 'address.cityValidation'
                : city.touched || city.dirty
              | transloco
          "
        >
        </markant-input>
      </div>
      @if (userForm.get('address.countryCode'); as countryCode) {
        <markant-platform-ui-country-select
          id="organizationCountry"
          name="countryCode"
          data-cy="select-country"
          [control]="$any(countryCode)"
          [label]="'address.country' | transloco"
          [outlined]="true"
          [error]="
            countryCode.errors
              | formControlKeyError
                : 'address.countryValidation'
                : countryCode.touched || countryCode.dirty
              | transloco
          "
        >
        </markant-platform-ui-country-select>
      }
    </markant-platform-ui-card>
  </ng-template>

  <ng-template #organizationdata>
    <markant-platform-ui-card
      [headline]="'user.details.organization' | transloco"
    >
      <markant-input
        data-cy="input-organization-name"
        *ngIf="isPlatformAdmin"
        formControlName="organizationName"
        [outlined]="true"
        [label]="'user.organization.name' | transloco"
      >
      </markant-input>
      <markant-select
        *ngIf="userForm.controls['department'] as department"
        formControlName="department"
        [options]="departmentAffiliationOptions"
        [outlined]="true"
        [label]="'user.department' | transloco"
        [error]="
          department.errors
            | formControlKeyError
              : 'user.position.validation'
              : department.touched || department.dirty
            | transloco
        "
        [helper]="
          department.errors
            | formControlKeyError
              : 'user.position.validation'
              : department.touched || department.dirty
            | transloco
        "
      >
      </markant-select>
      <markant-input
        *ngIf="userForm.controls['position'] as position"
        formControlName="position"
        data-cy="input-position"
        autocomplete="new-password"
        [outlined]="true"
        [label]="'user.position' | transloco"
        [error]="
          position.errors | formControlError: position.touched || position.dirty
        "
        [errorText]="
          position.errors
            | formControlKeyError
              : 'user.position.validation'
              : position.touched || position.dirty
            | transloco
        "
      >
      </markant-input>
    </markant-platform-ui-card>
  </ng-template>
</form>

<ng-template #platformroles>
  <markant-platform-ui-card [headline]="'user.role' | transloco">
    <form [formGroup]="organizationRoleForm">
      <markant-select
        *ngIf="
          organizationRoleOptions.length &&
          organizationRoleForm.controls['organizationRole'] as organizationRole
        "
        formControlName="organizationRole"
        [options]="organizationRoleOptions"
        [outlined]="true"
        [label]="'common.role' | transloco"
      >
      </markant-select>
    </form>
  </markant-platform-ui-card>
</ng-template>
